import React from 'react'
import '../css/resumen.css'
import DetalleInicialCompany from './DetalleInicialCompany'

export const Resumen = () => {

    return (
        <DetalleInicialCompany />
    )
}
